var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertBellNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1764_59142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.75 38.25C61.6911 38.25 69.75 30.1911 69.75 20.25C69.75 10.3089 61.6911 2.25 51.75 2.25C41.8089 2.25 33.75 10.3089 33.75 20.25C33.75 30.1911 41.8089 38.25 51.75 38.25Z",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.75 29.25C51.1287 29.25 50.625 28.7463 50.625 28.125C50.625 27.5037 51.1287 27 51.75 27",
    stroke: "#1F76FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.75 29.25C52.3713 29.25 52.875 28.7463 52.875 28.125C52.875 27.5037 52.3713 27 51.75 27",
    stroke: "#1F76FF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.75 20.25V11.25",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.515 47.586C53.1216 50.7093 54.3957 53.6646 56.25 56.25H2.25C2.25 56.25 6.75 49.263 6.75 31.5C6.75 25.5326 9.12054 19.8097 13.3401 15.5901C17.5597 11.3705 23.2826 9 29.25 9V2.25",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2439 65.25C23.6249 66.5481 24.4162 67.6878 25.4991 68.4984C26.5821 69.3093 27.8985 69.7476 29.2514 69.7476C30.6041 69.7476 31.9205 69.3093 33.0035 68.4984C34.0865 67.6878 34.8779 66.5481 35.2589 65.25",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1764_59142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertBellNotification);
export default __webpack_public_path__ + "static/media/AlertBellNotification.c500b2b967929e3da0adee9434f524c3.svg";
export { ForwardRef as ReactComponent };